import { h } from "preact";

import CSSProperties from "../../../../foundation/model/CSSProperties";
import classname from "../../../../foundation/utils/classname";
import PlaceholderBlock from "../../PlaceholderBlock";
import {
    SCREEN_CARD_WIDTH,
    SCREEN_CARD_THUMBNAIL_WIDTH
} from "../specs";

import styles from "./ScreenCardPlaceholder.module.css";

interface Props {
    class?: string;
    thumbnailHeight: number;
}

function ScreenCardPlaceholder({
    class: cssClass,
    thumbnailHeight
}: Props) {
    const style = {
        "--screen-card-width": `${SCREEN_CARD_WIDTH}px`,
        "--screen-card-thumbnail-width": `${SCREEN_CARD_THUMBNAIL_WIDTH}px`,
        "--screen-card-thumbnail-height": `${thumbnailHeight}px`
    } as CSSProperties;

    return (
        <div
            class={classname(styles.screenCardPlaceholder, cssClass)}
            style={style}>
            <PlaceholderBlock class={styles.thumbnail}/>
            <div class={styles.info}>
                <PlaceholderBlock class={styles.name}/>
                <PlaceholderBlock class={styles.date}/>
            </div>
        </div>
    );
}

export default ScreenCardPlaceholder;
